import React from "react";

const preventDefault = (ev: Event) => {
  if (ev.preventDefault) {
    ev.preventDefault();
  }
  ev.returnValue = false;
};

const enableBodyScroll = () => {
  document && document.removeEventListener("wheel", preventDefault, false);
};
const disableBodyScroll = () => {
  document &&
    document.addEventListener("wheel", preventDefault, {
      passive: false
    });
};

function usePreventBodyScroll() {
  const disableScroll = React.useCallback(() => {disableBodyScroll()}, []);
  const enableScroll = React.useCallback(() => {enableBodyScroll()}, []);
  return { disableScroll, enableScroll };
}

export default usePreventBodyScroll;
